<script setup>
import { useWebSiteStore } from '@/stores/website.store'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const props = defineProps({
  isOpen: { type: Boolean, default: false }
})
const emit = defineEmits(['update:isOpen'])

const websiteStore = useWebSiteStore()
const route = useRoute()
const items = computed(() => websiteStore.menuItems())

const isActive = (item) => {
  return item.route?.some(r => r === route.path)
}
</script>

<template>
  <q-drawer
    :model-value="props.isOpen"
    side="left"
    bordered
    @update:model-value="(val) => emit('update:isOpen', val)"
  >
    <q-list>
      <template
        v-for="item in items"
        :key="item.id"
      >
        <q-item
          v-ripple
          clickable
          :class="{ 'text-primary': isActive(item), 'text-disabled': item.canAccess === false }"
          :disable="item.canAccess === false"
          @click="item.onClick"
        >
          <q-item-section side>
            <q-icon
              :name="item.icon"
              :color="isActive(item) ? 'primary' : undefined"
            />
          </q-item-section>
          <q-item-section>{{ $t(item.label) }}</q-item-section>
        </q-item>
        <q-separator />
      </template>
    </q-list>
  </q-drawer>
</template>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.rm-active-item {
  color: $primary;
  background-color: rgba($primary, 0.1);
}
</style>
